import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useUrlSearchParams } from "use-url-search-params";
import { Breadcrumb, Table } from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { useList } from 'modules/aiRequirementsSearch/hooks';

const PER_PAGE = 20;

const AISearch = () => {
  const { t } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  const search = params.search || '';

  const [loading, _] = useState(false);

  const defaultParams = {
    page: params.page,
    perPage: params.perPage || PER_PAGE,
    searchText: search
  }
  const { items, meta, isFetched } = useList({
    params: defaultParams
  });

  const columns = [
    {
      title: '№',
      render: (_, __, index) => (params.page - 1) * PER_PAGE + index + 1,
      width: 60
    },
    {
      title: t('ai_search_score'),
      dataIndex: 'score',
      key: 'score',
      width: 120
    },
    {
      title: t('ai_search_requirement_name'),
      dataIndex: 'text',
      key: 'text'
    }
  ];

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        <Breadcrumb.Item href="/">{t('home')}</Breadcrumb.Item>
        <Breadcrumb.Item href="/mandatory-requirement/register">{t('mandatory-requirements')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('ai_requirements_search')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align="left" text={`${t('ai_requirements_search')}: "${search}"`} />

      <Spacer size={40} />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={items}
        pagination={false}
        loading={loading}
        scroll={{ x: 800 }}
        locale={{
          emptyText: t("requirements-not-found")
        }}
      />

      <Spacer size={32} />

      <Pagination
        current={meta.page}
        perPage={meta.perPage}
        total={Math.ceil(meta.total / PER_PAGE)}
        currentItems={items.length}
        totalItems={meta.total}
        onChange={page => setParams({ page })}
        onPerPageChange={perPage => setParams({ perPage })}
      />

      <Spacer size={140} />
    </Container>
  );
};

export default AISearch;
